import { TableRowProps, Tr } from '@chakra-ui/react';

export function PFTr({
  clickable = false,
  ...props
}: TableRowProps & {
  clickable?: boolean;
}): JSX.Element {
  if (!clickable) {
    return <Tr {...props} />;
  }

  return (
    <Tr
      cursor="pointer"
      _hover={{ backgroundColor: 'palette_blue.0' }}
      {...props}
    />
  );
}
